import { request } from "./client";
import USE_MOCK from "../mock/config";
import {
  mockFetchTenantServices, mockCreateTenantService, mockUpdateTenantService,
} from "../mock/mockHandlers";

const botServicesPath = (botId) => `/bots/${botId}/services`;

export const fetchTenantServices = (tenantId) =>
  USE_MOCK ? mockFetchTenantServices(tenantId) : request(botServicesPath(tenantId));
export const createTenantService = (tenantId, payload) =>
  USE_MOCK ? mockCreateTenantService(tenantId, payload) : request(botServicesPath(tenantId), { method: "POST", data: payload });
export const updateTenantService = (tenantId, serviceKey, payload) =>
  USE_MOCK ? mockUpdateTenantService(tenantId, serviceKey, payload) : request(`${botServicesPath(tenantId)}/${serviceKey}`, { method: "PUT", data: payload });
